export type AIModelOption =
  | 'gpt-6-astra'
  | 'gpt-5.6-terra'
  | 'gpt-5.6-luna'
  | 'gpt-5.5'
  | 'gpt_5_4_mini'
  | 'gpt_5_5_blueprint_5_4_mini'
  | 'mini_nano';

export type AIActionModelOption = AIModelOption;
export type AIMealPlanCohort = 'hybrid' | 'gpt55_medium' | 'internal';

export const DEFAULT_AI_ACTION_MODEL: AIActionModelOption = 'gpt-6-astra';

export const AI_MODEL_OPTIONS: Array<{ value: AIModelOption; label: string }> = [
  { value: 'gpt-6-astra', label: 'Astra + Terra' },
];

export interface AIMealPlanGenerationOption {
  value: AIModelOption;
  label: string;
}

export interface AIMealPlanCohortPayload {
  assignedCohort: AIMealPlanCohort | null;
  effectiveCohort: AIMealPlanCohort;
  defaultModel: AIModelOption;
  generationOptions: AIMealPlanGenerationOption[];
  actionModel: AIActionModelOption;
}

export const AI_MEAL_PLAN_COHORT_OPTIONS: Array<{
  value: AIMealPlanCohort;
  label: string;
}> = [
  { value: 'hybrid', label: 'GPT-5.6 Fast' },
  { value: 'gpt55_medium', label: 'GPT-5.6 Complex Reasoning' },
  { value: 'internal', label: 'GPT-5.6 Internal' },
];

export const DEFAULT_AI_MEAL_PLAN_COHORT_PAYLOAD: AIMealPlanCohortPayload = {
  assignedCohort: null,
  effectiveCohort: 'hybrid',
  defaultModel: 'gpt-6-astra',
  generationOptions: AI_MODEL_OPTIONS,
  actionModel: DEFAULT_AI_ACTION_MODEL,
};

export function getAIMealPlanCohortLabel(value?: string | null): string {
  return AI_MEAL_PLAN_COHORT_OPTIONS.find((option) => option.value === value)?.label || 'GPT-5.6 Fast';
}

export const AI_ACTION_MODEL_OPTIONS: Array<{
  value: AIActionModelOption;
  label: string;
  shortLabel: string;
}> = [
  {
    value: 'gpt-6-astra',
    label: 'GPT-5.6 Terra',
    shortLabel: 'Terra',
  },
  {
    value: 'gpt-5.6-luna',
    label: 'GPT-5.6 Luna',
    shortLabel: 'Luna',
  },
];

const AI_MODEL_LABELS: Record<string, string> = {
  'gpt-6-astra': 'GPT-6 Astra',
  'gpt-5.6-terra': 'GPT-5.6 Terra',
  'gpt-5.6-luna': 'GPT-5.6 Luna',
  gpt_5_4_mini: 'GPT-5.5 Medium',
  gpt_5_5: 'GPT-5.5 Medium',
  gpt_5_5_blueprint_5_4_mini: 'Hybrid: GPT-5.5 Blueprint + 5.4 Mini',
  mini_nano: 'Hybrid: GPT-5.5 Blueprint + 5.4 Mini',
  openai: 'GPT-5.5 Medium',
  ai_openai: 'GPT-5.5 Medium',
  ai_mini_nano: 'Hybrid: GPT-5.5 Blueprint + 5.4 Mini',
  'gpt-5.5': 'GPT-5.5 Medium',
  'gpt-5.4-mini': 'GPT-5.4 Mini',
  'gpt-5.4-nano': 'GPT-5.4 Nano',
};

export function getAIModelLabel(value?: string | null): string {
  const key = String(value || '').trim();
  if (!key) return 'AI Model';
  return AI_MODEL_LABELS[key] || key;
}
